import React, { useEffect, useState } from 'react';
import { constantStyles } from '../constants/constantStyles';
import { RiArrowUpSFill } from "react-icons/ri";
import { useMediaQuery } from 'react-responsive';

let options = [
    { text: 'Relevance', value: 'relevance' },
    { text: 'Newest', value: 'newest' },
    { text: 'Price: Low to High', value: 'price_low_to_high' },
    { text: 'Price: High to Low', value: 'price_high_to_low' },
];

const optionsIconSize = 20;
const optionsYMargin = 10;

const SortDropdown = ({ onSortChange, currentSort }) => {

    const isMobile = useMediaQuery({ maxWidth: constantStyles.mobileWidth });

    const [isOpen, setIsOpen] = useState(isMobile);

    const [selectedOption, setSelectedOption] = useState(options.find(option => option.value === currentSort));

    const maxHeight = `${options.length * (optionsIconSize + optionsYMargin)}px`;

    const displayText = isMobile ?
        selectedOption ? 'Sort by: ' + selectedOption.text : 'Sort by'
        :
        selectedOption ? selectedOption.text : 'Sort by';

    return (
        <div style={isMobile ? styles.sortContainerMobile : styles.sortContainer} onClick={() => setIsOpen(!isOpen)}>
            <div style={styles.selectedOption}>
                {displayText}
                <RiArrowUpSFill
                    style={{
                        transition: "transform 0.3s ease-in-out",
                        transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
                    }} />
            </div>
            <div style={{
                ...styles.optionsContainer,
                maxHeight: isOpen ? maxHeight : '0',
            }}>
                <div>
                    {options.map(option => (
                        <div style={styles.option}
                            key={option.text}
                            onClick={() => {
                                onSortChange(option.value);
                                setSelectedOption(option);
                            }}
                        >
                            {option.text}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
const styles = {
    sortContainer: {
        display: 'flex',
        position: 'absolute',
        right: '0',
        top: '14px',
        height: 'max-content',
        width: '100%',
        border: '1px solid',
        padding: '10px',
        fontFamily: constantStyles.mainFontFamily,
        flexGrow: 1,
        minWidth: '150px',
        maxWidth: '150px',
        marginRight: '24px',
        cursor: "pointer",
        flexDirection: 'column',
        backgroundColor: constantStyles.mainBackgroundColor,
        zIndex: 10,

    },
    sortContainerMobile: {
        display: 'flex',
        height: 'max-content',
        width: '100%',
        fontFamily: constantStyles.mainFontFamily,
        flexGrow: 1,
        minWidth: '150px',
        cursor: "pointer",
        flexDirection: 'column',
        backgroundColor: constantStyles.mainBackgroundColor,
        marginBottom: '20px',
        zIndex: 10,
    },
    selectedOption: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    optionsContainer: {
        marginLeft: '15px',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease-in-out',
    },
    option: {
        margin: optionsYMargin + 'px 0',
    },
};
export default SortDropdown;